const VGSearch = {
	container: 'search-advanced',
	result: 'search-advanced-result',
	form: 'search-advanced-form',

	init: function (self) {
		let _this = this;

		self.onclick = function () {
			if (document.body.classList.contains('search-open')) {
				_this.toggle(this, true);
			} else {
				_this.toggle(this, false);
			}

			return false;
		}
	}, 
	
	toggle: function (self, isOpen) {
		let _this = this;

		if (isOpen) {
			_this.hide(self);
		} else {
			_this.show(self);
		}

		document.onkeyup = function (e) {
			if (e.key === "Escape") {
				_this.hide(self);
			}

			return false;
		}
	},

	show: function (self) {
		document.body.style.overflow = 'hidden';
		document.body.classList.add('search-open');
		self.innerHTML = '<i class="fal fa-xmark"></i>';

		const input = document.querySelector('#' + this.form + ' input');
		if (input) {
			input.focus();
		}
	},

	hide: function (self) {
		document.body.style.overflow = 'auto';
		document.body.classList.remove('search-open');
		self.innerHTML = '<i class="fal fa-search"></i>';
	}
}

function onReady() {
	let $search = document.querySelectorAll('[data-vg-toggle="search"]');
	if ($search.length) {
		for (let search of $search) {
			VGSearch.init(search);
		}
	}

	let $searchKeys = document.querySelectorAll('[data-keysearch]');
	if ($searchKeys.length) {
		for (let key of $searchKeys) {
			key.onclick = function () {
				let $container = document.getElementById(VGSearch.container),
					input = $container.querySelector('input');
				if(input) {
					input.value = this.dataset.keysearch;
					input.closest('form').submit();
				}

				return false;
			}
		}
	}
}

document.addEventListener("DOMContentLoaded", onReady);

export default VGSearch;